import React, { useState } from 'react';
import './TexturePanel.css';

const TexturePanel = ({ textures, selectedTexture, onSelectTexture, onAddTexture, showDots, onToggleDots }) => {
    const [isOpen, setIsOpen] = useState(false);

    const togglePanel = () => {
        setIsOpen(!isOpen);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && onAddTexture) {
            onAddTexture(file);
        }
    };

    return (
        <div className={`texture-panel ${isOpen ? 'open' : ''}`}>
            <button className="texture-toggle-tab" onClick={togglePanel}>
                <span className="toggle-text-vertical">TEXTURES</span>
            </button>

            <div className="panel-content">
                <div className="panel-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h2 style={{ margin: 0 }}>TEXTURES</h2>
                    <label className="dots-toggle" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.8rem' }}>
                        <input
                            type="checkbox"
                            checked={showDots}
                            onChange={onToggleDots}
                            style={{ marginRight: '5px' }}
                        />
                        Afficher points
                    </label>
                </div>
                <div className="upload-section">
                    <label className="upload-btn">
                        + UPLOAD
                        <input type="file" hidden onChange={handleFileChange} accept="image/*" />
                    </label>
                    <p className="helper-text">Glissez ou cliquez pour ajouter</p>
                </div>

                <div className="texture-grid">
                    {textures && textures.map((texture) => (
                        <div
                            key={texture.id}
                            className={`texture-item ${selectedTexture?.id === texture.id ? 'selected' : ''}`}
                            onClick={() => onSelectTexture(selectedTexture?.id === texture.id ? null : texture)}
                            style={{ '--texture-color': texture.color }}
                        >
                            {/* Afficher l'image de la texture si disponible */}
                            {texture.preview ? (
                                <img src={texture.preview} alt={texture.name} className="texture-preview-img" />
                            ) : (
                                <div className="texture-color-preview" style={{ backgroundColor: texture.color }}></div>
                            )}

                            {/* Pastille de couleur indiquant le lien */}
                            <div className="texture-indicator" style={{ backgroundColor: texture.color }}></div>

                            <span className="texture-name">{texture.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TexturePanel;
